export class VersionOperation
{
    static forEach(v1: string, v2: string, handler: (e1: number, e2: number) => boolean, onEqual: boolean): boolean
    {
        if (!v1 || !v2)
            return false;
        let t1s = v1.split('.');
        let t2s = v2.split('.');
        let len = Math.max(t1s.length, t2s.length);
        for (let i = 0; i < len; i++)
        {
            let e1 = 0;
            let e2 = 0;
            if (i < t1s.length)
                e1 = parseInt(t1s[i]);
            if (i < t2s.length)
                e2 = parseInt(t2s[i]);
            if (e1 != e2)
                return handler(e1, e2);
        }
        return onEqual;
    }
    static isGreaterThan(v1: string, v2: string): boolean
    {
        return this.forEach(v1, v2, (e1: number, e2: number) => e1 > e2, false);
    }

    static isLessThan(v1: string, v2: string): boolean
    {
        return this.forEach(v1, v2, (e1: number, e2: number) => e1 < e2, false);
    }

    static isEqual(v1: string, v2: string): boolean
    {
        return this.forEach(v1, v2, () => false, true);
    }

    static isGreaterThanOrEqual(v1: string, v2: string): boolean
    {
        return this.forEach(v1, v2, (e1: number, e2: number) => e1 > e2, true);
    }

    static isLessThanOrEqual(v1: string, v2: string): boolean
    {
        return this.forEach(v1, v2, (e1: number, e2: number) => e1 < e2, true);
    }
}